module.exports = __webpack_public_path__ + "static/media/instagram.fac0c03c.png";